import { useEffect, useState } from 'react'
import { api } from '../api.js'

const FILTRES = [
  ['open', 'En cours'], ['hot', 'Prioritaires'], ['all', 'Tous'], ['closed', 'Clôturés'],
]

export default function Dossiers({ onOuvrir }) {
  const [filtre, setFiltre] = useState('open')
  const [q, setQ] = useState('')
  const [liste, setListe] = useState([])

  useEffect(() => {
    const t = setTimeout(() => api.requests(filtre, q).then(setListe).catch(() => setListe([])), 150)
    return () => clearTimeout(t)
  }, [filtre, q])

  return (
    <>
      <h1>Dossiers</h1>
      <p className="chapo">Chaque dossier suit le circuit attaché à sa démarche. Ouvrez-en un pour
        voir les boutons dont vous disposez.</p>

      <div class="barre">
        <div className="onglets" role="tablist">
          {FILTRES.map(([id, label]) => (
            <button key={id} role="tab" aria-selected={filtre === id}
                    className={filtre === id ? 'on' : ''} onClick={() => setFiltre(id)}>{label}</button>
          ))}
        </div>
        <input type="search" value={q} onChange={(e) => setQ(e.target.value)}
               placeholder="Rechercher un nom, un numéro…" aria-label="Rechercher" />
      </div>

      <table className="tableau">
        <thead>
          <tr><th>Numéro</th><th>Démarche</th><th>Demandeur</th><th>Étape</th><th>Mise à jour</th></tr>
        </thead>
        <tbody>
          {liste.map((r) => (
            <tr key={r.id} onClick={() => onOuvrir(r.id)} tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onOuvrir(r.id)}>
              <td className="mono">
                {r.criticity !== 'normal' && <span className={`pastille ${r.criticity}`} title="Prioritaire" />}
                {r.number}
              </td>
              <td><strong>{r.title}</strong>
                {r.awaiting && <span className="attente">réponse attendue de l'habitant</span>}</td>
              <td>{r.applicant?.name}</td>
              <td><span className={`etat ${r.tone}`}>{r.status}</span></td>
              <td className="mono">{new Date(r.updated_at).toLocaleDateString('fr-FR')}</td>
            </tr>
          ))}
          {!liste.length && <tr><td colSpan={5} className="vide">Aucun dossier ici.</td></tr>}
        </tbody>
      </table>
    </>
  )
}
